module.exports = __webpack_public_path__ + "static/media/efficiency.4cdf0109.png";